// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".design-block[data-v-5e2b82e5]{width:auto;height:auto;position:absolute;background-repeat:no-repeat;background-origin:content-box;background-size:auto 100%}.design-block_left[data-v-5e2b82e5],.design-block_left-2[data-v-5e2b82e5]{display:none;background-position:0}.design-block_right[data-v-5e2b82e5],.design-block_right-2[data-v-5e2b82e5]{display:none;background-position:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
